import { EditorJsOutputData } from "@dashboard/utils/richText/types";

import { PageTypeContentModule } from "./types";

export const defaultStorefrontSectionsContent: PageTypeContentModule = {
  pageTypeSlug: "storefront-sections",
  suggestedTitles: ["Featured Products", "Best Sellers", "New Arrivals", "Shop by Category"],
  suggestedSlugs: ["featured", "best-sellers", "new-arrivals", "categories"],
  description: "Storefront sections and homepage content",

  content: {
    time: Date.now(),
    blocks: [
      {
        type: "header",
        data: { text: "Welcome to Our Store", level: 1 },
      },
      {
        type: "paragraph",
        data: {
          text: "Discover our curated selection of premium products. We're committed to providing you with the best shopping experience.",
        },
      },
      {
        type: "header",
        data: { text: "Featured Categories", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: [
            "Category 1 - Explore Now",
            "Category 2 - New Arrivals",
            "Category 3 - Best Sellers",
            "Category 4 - On Sale",
          ],
        },
      },
      {
        type: "header",
        data: { text: "Why Shop With Us", level: 2 },
      },
      {
        type: "list",
        data: {
          style: "unordered",
          items: [
            "Fast and free shipping",
            "30-day money-back guarantee",
            "24/7 customer support",
            "Secure checkout",
          ],
        },
      },
    ],
    version: "2.20.0",
  } as EditorJsOutputData,
};
